import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

function SubscriptionWarningModal({ isOpen, toggle }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>SUBSCRIPTION ALERT</ModalHeader>
      <ModalBody>
        <p>
          No subscription found in Stripe with your email, please contact{' '}
          <a
            href="mailto:support@promotionwingman.com"
            className="mailto__anchor"
          >
            support@promotionwingman.com
          </a>
          .
        </p>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-primary btn-submit"
          onClick={() => {
            toggle();
          }}
        >
          Understood
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default SubscriptionWarningModal;
